/**
 * ShrineActivationPanel - UI for activating shrines when standing on them
 *
 * Shows:
 * - Shrine name and icon
 * - Blessing effect description
 * - Activation button (if not activated)
 * - Blessed status (if already activated)
 */

import React from 'react';
import { SHRINE_BIOMES } from '../../../data/world-map/shrineBiomes';

// Helper to get human-readable shrine effect description
const getShrineEffectDescription = (shrineEffect) => {
  if (!shrineEffect) return '';
  switch (shrineEffect.type) {
    case 'stat':
      return `+${shrineEffect.value} ${shrineEffect.stat} permanently`;
    case 'health':
      return `+${shrineEffect.value} Max HP permanently`;
    case 'xp':
      return `${shrineEffect.multiplier}× your level in XP`;
    case 'random_blessing':
      return 'Random permanent blessing';
    default:
      return 'Unknown blessing';
  }
};

function ShrineActivationPanel({
  biomeId,
  isActivated,
  onActivate,
}) {
  const shrineBiome = SHRINE_BIOMES[biomeId];

  if (!shrineBiome) return null;

  return (
    <div className="wm-shrine-panel">
      <div className="wm-shrine-header">
        <span className="wm-shrine-icon">{shrineBiome.icon}</span>
        <span className="wm-shrine-name">{shrineBiome.name}</span>
      </div>
      <div className="wm-shrine-effect-inline">
        <span className="wm-shrine-effect-label">Blessing:</span>
        <span className="wm-shrine-effect-value">
          {getShrineEffectDescription(shrineBiome.shrineEffect)}
        </span>
      </div>
      {!isActivated ? (
        <button
          className="wm-shrine-activate-btn"
          onClick={onActivate}
        >
          🙏 Receive Blessing
        </button>
      ) : (
        <div className="wm-shrine-activated-info">
          <span className="wm-shrine-blessed-icon">✨</span>
          <span>Blessed: {isActivated.bonusApplied}</span>
        </div>
      )}
    </div>
  );
}

export default ShrineActivationPanel;
